import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import Error404 from '../cmtComponents/errors/Error404';
import Error500 from '../cmtComponents/errors/Error500';
import Logo from '../cmtComponents/navbar/Logo';
import Section from '../components/common/Section';

const ErrorLayout = () => (
  <Section className="py-0">
    <Row className="flex-center min-vh-100 py-6">
      <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
        <Logo />
        <Routes>
          <Route path="404" element={<Error404 />} />
          <Route path="500" element={<Error500 />} />
          <Route path="*" element={<Navigate to="404" replace />} />
        </Routes>
      </Col>
    </Row>
  </Section>
);

export default ErrorLayout;
